import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterExpiredDiscountCodes"];
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getEcommerceStoresRpc } from '../../__generated__/chirp/com/hubspot/website/interactive/rpc/WebsiteInteractiveStoresService';
import { ECOMMERCE_OBJECT_TYPES, ECOMMERCE_OBJECT_TYPE_IDS, DISCOUNT_CODE_STATUS_PROPERTY, DISCOUNT_CODE_EXPIRED_STATUS } from '../constants/ecommerce';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function fetchStores() {
  return rpcClient.call(getEcommerceStoresRpc, {});
}
export function fetchConnections({
  storeAccountId,
  appId
}) {
  return http.get(`sync-bridge/v3/accounts/${storeAccountId}/connections`, {
    query: {
      appId
    }
  });
}
export async function fetchObjects(query) {
  var _response$results;
  const {
      filterExpiredDiscountCodes
    } = query,
    fetchQuery = _objectWithoutPropertiesLoose(query, _excluded);
  const response = await http.get(`sync-health/v1/record/list`, {
    query: Object.assign({}, fetchQuery, {
      status: 'IN_SYNC'
    })
  });
  if (!filterExpiredDiscountCodes || query.objectType !== ECOMMERCE_OBJECT_TYPES.DISCOUNT_CODE || !((_response$results = response.results) !== null && _response$results !== void 0 && _response$results.length)) {
    return response;
  }
  try {
    const objectIds = response.results.map(r => r.hubSpotObjectId);
    const expiredIds = await fetchExpiredDiscountCodeIds(objectIds);
    if (expiredIds.size === 0) {
      return response;
    }
    const filteredResults = response.results.filter(r => !expiredIds.has(r.hubSpotObjectId));
    return Object.assign({}, response, {
      total: response.total - (response.results.length - filteredResults.length),
      results: filteredResults
    });
  } catch (_unused) {
    return response;
  }
}
async function fetchExpiredDiscountCodeIds(objectIds) {
  const response = await http.post('crm-search/search', {
    data: {
      objectTypeId: ECOMMERCE_OBJECT_TYPE_IDS.DISCOUNT_CODE,
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: 'hs_object_id',
          values: objectIds.map(String)
        }]
      }],
      requestOptions: {
        properties: [DISCOUNT_CODE_STATUS_PROPERTY]
      },
      count: objectIds.length
    }
  });
  const expiredIds = new Set();
  response.results.forEach(result => {
    var _result$properties$DI;
    if (result.objectId !== null && ((_result$properties$DI = result.properties[DISCOUNT_CODE_STATUS_PROPERTY]) === null || _result$properties$DI === void 0 ? void 0 : _result$properties$DI.value) === DISCOUNT_CODE_EXPIRED_STATUS) {
      expiredIds.add(result.objectId);
    }
  });
  return expiredIds;
}